export default __webpack_public_path__ + "static/media/log-or-logback-en.4b2f2ef4.png";